import request from '../kernel/request'

export default {
	course: {
		list(params) {
			return request.get('online/course', params)
		},
		page(params) {
			return request.get('online/course/page', params)
		},
		save(data) {
			return request.post(`online/course/save`, data)
		},
		update(data) {
			return request.put(`online/course`, data)
		},
		delete(id) {
			return request.delete('online/course/' + id)
		},
		load(id) {
			return request.get('online/course/' + id)
		},
		uploadPhoto: `${request.baseURL}/online/course/uploadPhoto`,
	},
	live: {
		list(params) {
			return request.get('online/live', params)
		},
		page(params) {
			return request.get('online/live/page', params)
		},
		save(data) {
			return request.post(`online/live/save`, data)
		},
		update(data) {
			return request.put(`online/live`, data)
		},
		delete(id) {
			return request.delete('online/live/' + id)
		},
		load(id) {
			return request.get('online/live/' + id)
		},
		open(id) {
			return request.get('online/live/open/' + id)
		},
		finish(id) {
			return request.put('online/live/finish/' + id)
		},
		video(id) {
			return request.get('online/live/video/' + id)
		},
		uploadCover: `${request.baseURL}/online/live/uploadCover`,
	}
}